import React from "react";
import { toast } from "react-toastify";
// Common Components
import { Button, DynamicDropdown, TextInput } from "src/Components";
// Requests
import { getAssetTypesDropDown, updateAssetTypeOne } from "src/Requests/assetClass";
// Types
import type { IAssetClassTableReport } from "src/Interfaces/assetClass";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  row: IAssetClassTableReport;
  onSuccess: () => void;
}

const toInputValue = (value?: number | null) =>
  value != null ? value.toString() : "";

const EditAssetClassSingleModal: React.FC<IProps> = ({ row, onSuccess }) => {
  const [loading, setLoading] = React.useState(false);
  const [assetType, setAssetType] = React.useState<string>(
    row.assetType != null ? row.assetType.toString() : "",
  );
  const [minimumVolumePermit, setMinimumVolumePermit] = React.useState(
    toInputValue(row.minimum_volume_permit),
  );
  const [maximumVolumePermit, setMaximumVolumePermit] = React.useState(
    toInputValue(row.maximum_volume_permit),
  );
  const [priceTick, setPriceTick] = React.useState(toInputValue(row.price_tick));

  const submitHandler = () => {
    if (!row.instrumentId) {
      toast.error("شناسه نماد یافت نشد");
      return;
    }
    if (assetType === "") {
      toast.error("طبقه دارایی را انتخاب کنید");
      return;
    }
    if (minimumVolumePermit === "") {
      toast.error("حداقل حجم را وارد کنید");
      return;
    }
    if (maximumVolumePermit === "") {
      toast.error("حداکثر حجم را وارد کنید");
      return;
    }
    if (priceTick === "") {
      toast.error("تیک قیمتی را وارد کنید");
      return;
    }

    setLoading(true);
    updateAssetTypeOne({
      instrumentId: row.instrumentId,
      assetType: Number(assetType),
      minimum_volume_permit: Number(minimumVolumePermit),
      maximum_volume_permit: Number(maximumVolumePermit),
      price_tick: Number(priceTick),
    })
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          onSuccess();
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col justify-start items-start gap-4 min-w-[360px] p-2">
      <h4 className="font-bold">ویرایش طبقه دارایی</h4>
      <TextInput
        name="shortInstrumentName"
        label="نماد"
        extraLabel
        value={row.shortInstrumentName ?? ""}
        onChange={() => {}}
        readOnly
      />
      <DynamicDropdown
        dropdown={{
          name: "assetType",
          placeholder: "طبقه دارایی",
          extraLabel: true,
        }}
        getData={getAssetTypesDropDown}
        onChange={(_, value) => setAssetType(value)}
        value={assetType}
      />
      <TextInput
        name="minimum_volume_permit"
        label="حداقل حجم"
        extraLabel
        kind="number"
        value={minimumVolumePermit}
        onChange={(_, value) => setMinimumVolumePermit(value)}
      />
      <TextInput
        name="maximum_volume_permit"
        label="حداکثر حجم"
        extraLabel
        kind="number"
        value={maximumVolumePermit}
        onChange={(_, value) => setMaximumVolumePermit(value)}
      />
      <TextInput
        name="price_tick"
        label="تیک قیمتی"
        extraLabel
        kind="number"
        value={priceTick}
        onChange={(_, value) => setPriceTick(value)}
      />
      <Button
        text="ثبت"
        onClick={submitHandler}
        variant="contained"
        loading={loading}
      />
    </div>
  );
};

export default EditAssetClassSingleModal;
